import React, { useEffect } from "react";
// import AuthService from "../services/AuthService.ts"

export const AuthContext = React.createContext();

// export const AuthConsumer = AuthContext.Consumer;

export function AuthProvider({ children }) {
    useEffect(() => {
        let url = "/appConfig/contextpath-prd.json";

        if (
            window.location.href.indexOf("3000") !== -1 ||
            window.location.href.indexOf("white") !== -1
        ) {
            url = "/appConfig/contextpath.json";
        } else if (
            window.location.href.indexOf("yellow") !== -1 ||
            window.location.href.indexOf("acc") !== -1
        ) {
            url = "/appConfig/contextpath-acc.json";
        }

        fetch(url, {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                localStorage.setItem("QLep", atob(data.graphQlendpoint));
                localStorage.setItem("fnKey", data.fnKey);
                localStorage.setItem("gqlKey", data.gqlKey);
                localStorage.setItem("apiEndpoint", data.apiEndpoint);
                localStorage.setItem("bannerURL", data.bannerURL);
                console.log(localStorage);
            });
    }, []);

    const value = {};
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}